module.exports = __webpack_public_path__ + "static/media/my-account.f24eca43.png";